/**
 * Post-sign-in redirect targets. A login page that forwards to an arbitrary
 * `?next=` is an open redirect — the primitive a phishing link wants — so a value
 * is honored only when it is unambiguously a path on this origin.
 */
export const DEFAULT_NEXT = "/me";

export function safeNext(value: string | null | undefined): string {
  if (!value || !value.startsWith("/")) return DEFAULT_NEXT;
  // Browsers read both "//host" and "/\host" as protocol-relative URLs.
  if (value.startsWith("//") || value.startsWith("/\\")) return DEFAULT_NEXT;
  return value;
}

/** The sign-in link for a page that wants the user back afterward. */
export function loginPath(from: string): string {
  const next = safeNext(from);
  return next === DEFAULT_NEXT ? "/login" : `/login?next=${encodeURIComponent(next)}`;
}

export function signupPath(from: string): string {
  const next = safeNext(from);
  return next === DEFAULT_NEXT ? "/signup" : `/signup?next=${encodeURIComponent(next)}`;
}
